import React from 'react';
import {
  Box,
  Grid,  
  Typography,
  Container,
  Tabs,
  Tab,
} from '@mui/material';
import Footer from 'pages/Footer';
import NewVisit from './NewVisit';
import Revisit from './Revisit';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AddNewVisitForm: React.FC = () => {
  // const dispatch = useAppDispatch();
  const [value, setValue] = React.useState(0);
  const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  

  return (
    <Container sx={{ py: 2 }} maxWidth='xl'>
      <Box>
        <Grid
          container
          direction="column"
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            gap: 2
          }}
        >
          <Grid item>
            <Typography variant="h5" sx={{ mb: 3 }}>
              Add New Visit
            </Typography>
          </Grid>
          <Grid item>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
                <Tab label="New Visit" {...a11yProps(0)} />
                <Tab label="Revisit" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <NewVisit />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Revisit />
            </CustomTabPanel>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Container>
  );
};

export default AddNewVisitForm;
